import React from 'react';
import { translate } from 'react-i18next';
import FieldGroup from '../field_group/FieldGroup';
import Form from '../form/Form';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';

export class HeatToElectricalEnergyDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  getRenewableEnergyData() {
    return this.formRef.getFormData();
  }

  render() {
    const {
      name,
      entropy,
      volume,
      description,
      image,
    } = this.props.renewableEnergy;

    const { disabled, fieldErrors, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => this.formRef = ref}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="heat-to-electrical-energy-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('heat to electrical energy name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="heat-to-electrical-energy-entropy"
          field="entropy"
          type="number"
          label={<span>{t('entropy')} ({t('MJ/ton')})</span>}
          placeholder="80.24"
          value={entropy}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'hs')}
          {...customAttr}
        />
        <FieldGroup
          id="heat-to-electrical-energy-volume"
          field="volume"
          type="number"
          label={<span>{t('volume')} ({t('ton/year')})</span>}
          placeholder="8.30"
          value={volume}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'volume')}
          {...customAttr}
        />
        <FieldGroup
          id="heat-to-electrical-energy-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

HeatToElectricalEnergyDetail.defaultProps = {
  renewableEnergy: {},
};

export default translate('translations', { withRef: true })(HeatToElectricalEnergyDetail);



// WEBPACK FOOTER //
// ./src/components/renewable_energy/HeatToElectricalEnergyDetail.js